require('jquery-contextmenu');
require('./jquery-ui');
require('../jquery.hotkeys.js');
require('../jquery.simulate.js');
require('./jquery-extensoes');